import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../store/hooks';
import { setLoading } from '../store/slices/loaderSlice';
import OrderService from "../services/order.service";
import Layout from './Layout';
import './OrderStatus.css';
import { setError } from '../store/slices/errorSlice';

interface Props {
    isSuccess: boolean
}

const OrderStatus: React.FunctionComponent<Props> = ({ isSuccess }: Props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const [transactionId, setTransactionId] = useState<string | null>(null);

    useEffect(() => {
        const transactionIdParam = searchParams.get("transactionUuid")
        setTransactionId(transactionIdParam);
        if (transactionIdParam) {
            dispatch(setLoading(false));
        }
    }, [])

    if (!transactionId) {
        isSuccess = false;
    } else {
        if (isSuccess) {
            OrderService.updateOrder(transactionId, "de").then(() => {
                dispatch(setError(""));
            }).catch((e: Error) => {
                dispatch(setError(t("misc.genericError")));
                isSuccess = false;
            });
        }
    }

    const showSuccessContent = () => {
        return (
            <>
                <h5 dangerouslySetInnerHTML={{ __html: t("orderStatus.infoSuccess") }}></h5>
                <svg className="order-status-icon order-status-icon--success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
            </>
        );
    }

    const showFailedContent = () => {
        return (
            <>
                <h5 dangerouslySetInnerHTML={{ __html: t("orderStatus.infoFailed") }}></h5>
                <svg className="order-status-icon order-status-icon--danger" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
            </>
        );
    }

    return (
        <Layout>
            <div className="container-md">
                <div className="row">
                    <div className="col-12 pt-4 text-center">
                        <h1>
                            {t('orderStatus.title')}
                            {isSuccess && transactionId ? (
                                <span className="normal-case">
                                    : {transactionId.length > 10 ?
                                        <span className="small-text"><br />{transactionId}</span>
                                        : transactionId}
                                </span>
                            ) : null}
                        </h1>
                        {isSuccess ? showSuccessContent() : showFailedContent()}
                        <p className="mt-4" dangerouslySetInnerHTML={{ __html: t("orderStatus.footer") }}></p>
                    </div>
                </div>
            </div>
        </Layout>
    );

}

export default OrderStatus;